import React from 'react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Label } from '@/components/ui/Label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/Select';
import { Search, X } from 'lucide-react';

interface BlockedListFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedCustomerFilter: string;
  onCustomerFilterChange: (filter: string) => void;
  customers: Array<{ id: number; customer_name: string; customer_code: string }>;
  isSuperAdmin: boolean;
  loading: boolean;
  onReset: () => void;
}

export const BlockedListFilters: React.FC<BlockedListFiltersProps> = ({
  searchQuery,
  onSearchChange,
  selectedCustomerFilter,
  onCustomerFilterChange,
  customers,
  isSuperAdmin,
  loading,
  onReset,
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
        {/* 보안: 슈퍼관리자에게만 고객사 필터 표시 (기업 관리자는 절대 보이지 않음) */}
        {isSuperAdmin && Array.isArray(customers) && customers.length > 0 && (
          <div className="md:col-span-2 lg:col-span-2">
            <Label>고객사 필터</Label>
            <Select
              value={selectedCustomerFilter}
              onValueChange={(value) => {
                onCustomerFilterChange(value);
              }}
            >
              <SelectTrigger className="h-10">
                <SelectValue placeholder="전체 고객사" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem key="blocked-customer-all" value="all">
                  <span className="font-bold">전체 고객사</span>
                </SelectItem>
                <SelectItem key="blocked-customer-none" value="none">(미할당)</SelectItem>
                {customers.map((customer) => (
                  <SelectItem key={`blocked-customer-${customer.id}`} value={String(customer.id)}>
                    {customer.customer_name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
        <div className={`space-y-2 ${isSuperAdmin && Array.isArray(customers) && customers.length > 0 ? 'md:col-span-6 lg:col-span-8' : 'md:col-span-8 lg:col-span-10'}`}>
          <Label>검색</Label>
          <Input
            type="text"
            placeholder={isSuperAdmin ? '이메일, 도메인, 고객사명, 사유로 검색...' : '이메일, 도메인, 사유로 검색...'}
            value={searchQuery}
            onChange={(e) => {
              onSearchChange(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                // 클라이언트 사이드 필터링이므로 즉시 반영됨
              }
            }}
            className="w-full min-w-0"
          />
        </div>
        {/* 버튼들 - 오른쪽 정렬 (총 12칸 맞춤) */}
        <div className={`${isSuperAdmin && Array.isArray(customers) && customers.length > 0 ? 'md:col-span-4 lg:col-span-2' : 'md:col-span-4 lg:col-span-2'} flex items-end gap-2 flex-shrink-0`}>
          <Button
            variant="outline"
            onClick={onReset}
            disabled={loading}
            className="h-10"
          >
            <X className="mr-2 h-4 w-4" />
            초기화
          </Button>
          <Button
            onClick={() => {
              // 클라이언트 사이드 필터링이므로 즉시 반영됨
            }}
            disabled={loading}
            className="h-10"
          >
            <Search className="mr-2 h-4 w-4" />
            검색
          </Button>
        </div>
      </div>
    </div>
  );
};

